import { Injectable } from '@angular/core';
import { Actions, Store } from '@ngxs/store';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';

@Injectable()
export class UserSharedFacade {
  constructor(protected store: Store,
              protected actions$: Actions) {
  }

  //<editor-fold desc="Selectors">

  currentUser$ = this.store.select(FlatStates.AuthControlState.currentUser$);
  typedUsers$ = this.store.select(FlatStates.UserEntityState.typedEntities$);
  users$ = this.store.select(FlatStates.UserEntityState.entities$);
  usersArray$ = this.store.select(FlatStates.UserEntityState.usersArray$);
  user$ = this.store.select(FlatStates.UserSharedState.user$);

  //</editor-fold>

  //<editor-fold desc="Snapshot Selectors">

  snapshot_currentUser = () => this.store.selectSnapshot(FlatStates.AuthControlState.currentUser$);
  snapshot_user = () => this.store.selectSnapshot(FlatStates.UserSharedState.user$);

  //</editor-fold>

  //<editor-fold desc="Requests">

  requestGetUsers() {
    return this.store.dispatch(new FlatActions.UserSharedActions.GetUsers());
  }

  requestAddUser(user: FlatModels.UserEntityModels.User) {
    return this.store.dispatch(new FlatActions.UserEntityActions.AddEntity(user));
  }

  requestUpdateUser(user: FlatModels.UserEntityModels.User) {
    return this.store.dispatch(new FlatActions.UserEntityActions.UpdateEntity(user));
  }

  requestRemoveUser(user: FlatModels.UserEntityModels.User) {
    return this.store.dispatch(new FlatActions.UserEntityActions.RemoveEntity(user));
  }

  //</editor-fold>
}
